import axios from "axios";
import { Message } from "element-ui";
import defaultSettings from "@/settings";
import { getToken } from "@/utils/auth";
import {
  getRefreshToken,
  setToken,
  setRefreshToken,
  removeToken,
  removeRefreshToken,
} from "@/utils/auth";
import router from "@/router";

const { baseApi } = defaultSettings;

const service = axios.create({
  baseURL: baseApi,
});

service.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async function (error) {
    if (error && !error.response) {
      Message({
        message: error,
        type: "error",
        duration: 5e3,
      });
      return Promise.reject(error);
    }

    const {
      config,
      response: { status, data, data: { message = `` } = {} },
    } = error;

    // Попытка автоматического обновления access токена по refresh токену
    if (
      status === 401 &&
      config &&
      !config._retry &&
      !config.url.includes("/api/auth/refresh/")
    ) {
      const currentRefresh = getRefreshToken();

      if (currentRefresh) {
        config._retry = true;
        try {
          const body = new URLSearchParams();
          body.append("grant_type", "refresh_token");
          body.append("refresh_token", currentRefresh);

          const refreshResponse = await axios.post(
            `${baseApi}/api/auth/refresh/`,
            body,
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          );

          const { access_token, refresh_token } = refreshResponse.data || {};

          if (access_token && refresh_token) {
            setToken(access_token);
            setRefreshToken(refresh_token);

            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${access_token}`;

            return service(config);
          }
        } catch (e) {
          // Если обновить токен не удалось, ниже сработает стандартная обработка 401
        }
      }
    }

    if (status === 401) {
      removeToken();
      removeRefreshToken();
      Message({
        message: "Сессия истекла, войдите снова.",
        type: "warning",
        duration: 5e3,
      });
      const redirect = router.currentRoute && router.currentRoute.fullPath;
      router.push({
        path: "/login",
        query: redirect && redirect !== "/login" ? { redirect } : {},
      });
      return Promise.reject(error);
    }

    if (status === 422) {
      Message({
        message: `Ошибка валидации, проверьте данные.`,
        type: "warning",
        duration: 5e3,
      });
      return Promise.reject(data);
    }

    Message({
      message: message ? `${message} (${status})` : error.message,
      type: "error",
      duration: 5e3,
    });
    return Promise.reject(error);
  }
);

export default service;
